// src/pages/Schedule/AllSessions.jsx

import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  List,
  ListItem,
  Stack
} from "@mui/material";
import SessionItem from "./SessionItem";

export default function AllSessions({ sessions = [] }) {
  return (
    <Box
      sx={{
        width: "100%",
        px: { xs: 1, sm: 2, md: 3 },
        py: { xs: 2, md: 3 }
      }}
    >
      {/* Header */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "1rem", sm: "1.25rem" }
          }}
        >
          All Sessions ({sessions.length})
        </Typography>
      </Stack>

      {/* Empty State */}
      {sessions.length === 0 ? (
        <Box
          sx={{
            textAlign: "center",
            py: 6,
            borderRadius: 3,
            background: "#f9fafb",
            border: "1px dashed #e5e7eb"
          }}
        >
          <Typography
            sx={{
              color: "text.secondary",
              fontSize: { xs: "0.9rem", sm: "1rem" }
            }}
          >
            No sessions scheduled yet
          </Typography>
        </Box>
      ) : (
        <List disablePadding>
          {sessions.map((session) => (
            <ListItem
              key={session.id}
              disableGutters
              sx={{ mb: 2 }}
            >
              <Card
                elevation={1}
                sx={{
                  width: "100%",
                  borderRadius: 3,
                  transition: "0.2s",
                  "&:hover": {
                    boxShadow: 3
                  }
                }}
              >
                <CardContent
                  sx={{
                    px: { xs: 2, sm: 3 },
                    py: { xs: 2, sm: 2.5 }
                  }}
                >
                  <SessionItem
                    session={session}
                    showActions={false}
                  />
                </CardContent>
              </Card>
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  );
}